"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggablePieChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_charts_1 = require("@gooddata/sdk-ui-charts");
var react_dom_1 = require("react-dom");
var bucket_1 = require("../../../constants/bucket");
var properties_1 = require("../../../constants/properties");
var supportedProperties_1 = require("../../../constants/supportedProperties");
var uiConfig_1 = require("../../../constants/uiConfig");
var bucketConfig_1 = require("../../../utils/bucketConfig");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var propertiesHelper_1 = require("../../../utils/propertiesHelper");
var sort_1 = require("../../../utils/sort");
var pieChartUiConfigHelper_1 = require("../../../utils/uiConfigHelpers/pieChartUiConfigHelper");
var PieChartConfigurationPanel_1 = tslib_1.__importDefault(require("../../configurationPanels/PieChartConfigurationPanel"));
var PluggableBaseChart_1 = require("../baseChart/PluggableBaseChart");
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var PluggablePieChart = /** @class */ (function (_super) {
    tslib_1.__extends(PluggablePieChart, _super);
    function PluggablePieChart(props) {
        var _this = _super.call(this, props) || this;
        _this.type = sdk_ui_1.VisualizationTypes.PIE;
        _this.supportedPropertiesList = supportedProperties_1.PIECHART_SUPPORTED_PROPERTIES;
        _this.initializeProperties(props.visualizationProperties);
        return _this;
    }
    PluggablePieChart.prototype.getExtendedReferencePoint = function (referencePoint) {
        var _a;
        var clonedReferencePoint = cloneDeep_1.default(referencePoint);
        var newReferencePoint = tslib_1.__assign(tslib_1.__assign({}, clonedReferencePoint), { uiConfig: cloneDeep_1.default(uiConfig_1.DEFAULT_PIE_UICONFIG) });
        newReferencePoint = bucketHelper_1.removeAllArithmeticMeasuresFromDerived(newReferencePoint);
        newReferencePoint = bucketHelper_1.removeAllDerivedMeasures(newReferencePoint);
        var buckets = (_a = clonedReferencePoint === null || clonedReferencePoint === void 0 ? void 0 : clonedReferencePoint.buckets) !== null && _a !== void 0 ? _a : [];
        var attributes = bucketHelper_1.getAttributeItems(buckets);
        if (attributes.length) {
            var limitedBuckets = bucketHelper_1.limitNumberOfMeasuresInBuckets(buckets, 1);
            var limitedMeasures = bucketHelper_1.getMeasureItems(limitedBuckets);
            set_1.default(newReferencePoint, bucket_1.BUCKETS, [
                {
                    localIdentifier: sdk_ui_1.BucketNames.MEASURES,
                    items: limitedMeasures,
                },
                {
                    localIdentifier: sdk_ui_1.BucketNames.VIEW,
                    items: attributes.slice(0, 1),
                },
            ]);
        }
        else {
            var measures = bucketHelper_1.getMeasureItems(buckets);
            if (measures.length > 1) {
                set_1.default(newReferencePoint, uiConfig_1.UICONFIG, cloneDeep_1.default(uiConfig_1.PIE_UICONFIG_WITH_MULTIPLE_METRICS));
            }
            else {
                set_1.default(newReferencePoint, uiConfig_1.UICONFIG, cloneDeep_1.default(uiConfig_1.PIE_UICONFIG_WITH_ONE_METRIC));
            }
            set_1.default(newReferencePoint, bucket_1.BUCKETS, [
                {
                    localIdentifier: sdk_ui_1.BucketNames.MEASURES,
                    items: measures,
                },
                {
                    localIdentifier: sdk_ui_1.BucketNames.VIEW,
                    items: [],
                },
            ]);
        }
        newReferencePoint = pieChartUiConfigHelper_1.setPieChartUiConfig(newReferencePoint, this.intl, this.type);
        newReferencePoint = bucketConfig_1.configurePercent(newReferencePoint, false);
        newReferencePoint = bucketConfig_1.configureOverTimeComparison(newReferencePoint, !!this.featureFlags["enableWeekFilters"]);
        newReferencePoint = propertiesHelper_1.getReferencePointWithSupportedProperties(newReferencePoint, this.supportedPropertiesList);
        newReferencePoint = sort_1.removeSort(newReferencePoint);
        return Promise.resolve(bucketHelper_1.sanitizeFilters(newReferencePoint));
    };
    PluggablePieChart.prototype.renderConfigurationPanel = function (insight) {
        if (document.querySelector(this.configPanelElement)) {
            react_dom_1.render(react_1.default.createElement(PieChartConfigurationPanel_1.default, { locale: this.locale, properties: this.visualizationProperties, propertiesMeta: this.propertiesMeta, insight: insight, pushData: this.handlePushData, colors: this.colors, type: this.type, isError: this.getIsError(), isLoading: this.isLoading, featureFlags: this.featureFlags, references: this.references }), document.querySelector(this.configPanelElement));
        }
    };
    PluggablePieChart.prototype.buildVisualizationConfig = function (options, supportedControls) {
        var baseVisualizationConfig = _super.prototype.buildVisualizationConfig.call(this, options, supportedControls);
        if (this.environment === properties_1.DASHBOARDS_ENVIRONMENT) {
            return tslib_1.__assign(tslib_1.__assign({}, baseVisualizationConfig), { chart: {
                    verticalAlign: sdk_ui_charts_1.TOP,
                } });
        }
        return baseVisualizationConfig;
    };
    return PluggablePieChart;
}(PluggableBaseChart_1.PluggableBaseChart));
exports.PluggablePieChart = PluggablePieChart;
//# sourceMappingURL=PluggablePieChart.js.map